module.exports = "//public.zight.com/packs/media/images/bg-top-ac21e93d002eaa2f2c834c12f77f0742.png";